


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action, QuestionFileModel } from "survey-core";

@Component
export class FileChooseButton extends Vue {
  @Prop() data: any;
  @Prop() item: Action;
  get question(): QuestionFileModel {
    return (this.item && this.item.data.question) || this.data.question;
  }
}
Vue.component("sv-file-choose-btn", FileChooseButton);
export default FileChooseButton;
